// EIC-код (Energy Identification Code) і його тип об'єкта.
//
// Окремого поля з типом у моделі немає — ні в активі з бекенду
// (Asset.eicCode / Asset.eicWCode), ні в SCADA-довіднику (StationConfig.eicW).
// За стандартом ENTSO-E тип закодований у самому коді: символи 1-2 — код
// видавця (для України «62»), символ 3 — ТИП об'єкта:
//   W — точка обліку / приєднання, Z — зона або виробнича одиниця,
//   Y — балансуюча зона, X — учасник ринку, T — потужність, A — агрегат, V — лінія.
// Тому літеру беремо з коду, а не зашиваємо: у портфелі вже є і W (Болград,
// Табаки, Покров, Нікеліос, Нікополь), і Z (Лучки).

/** Тип об'єкта з EIC-коду, або null, якщо код порожній чи нестандартний. */
export function eicType(code?: string | null): string | null {
  const c = (code ?? '').trim().toUpperCase();
  return /^\d{2}[A-Z]/.test(c) ? c[2] : null;
}

/** Готовий підпис «W: 62W106817565247Y». Без типу — сам код. Без коду — null. */
export function formatEic(code?: string | null): string | null {
  const c = (code ?? '').trim().toUpperCase();
  if (!c) return null;
  const t = eicType(c);
  return t ? `${t}: ${c}` : c;
}
